module.exports = {
  "Incorrect file_id": "Неверный идентификатор_файла",
  "Incorrect printer_id": "Неверный ID_принтера",
  "No access": "Нет доступа",
  "No data given": "Нет данных",
  "Access denied": "Доступ закрыт",
  "You must have admin rights": "Вы должны иметь права администратора",
  "SSO auth": "SSO auth",
  "Incorrect session": "Неверный сеанс",
  "Error on printing start": "Ошибка при запуске печати",
  "Incorrect job_id": "Неверный job_id",
  "Wrong printer_id": "Неправильный принтер",
  "Invalid request data": "Неверные данные запроса",
  "Incorrect gcode file (not gcode or sliced for other printer type": "Неверный файл gcode (не gcode или нарезанный для другого типа принтера)",
  "Not all parameters exists": "Не все параметры существуют",
  "Page not found": "Страница не найдена",
  "Incorrect workflow_id": "Неверный workflow_id",
  "Access Denied": "В доступе отказано",
  "Bad request": "Плохой запрос",
  "Can't access gcode file": "Не могу получить доступ к файлу gcode",
  "Wrong request": "Неверный запрос",
  "Invalid request": "Неверный запрос",
  "Printer type not found": "Тип принтера не найден",
  "Some error on file upload": "Некоторая ошибка при загрузке файла",
  "Wrong method of request. POST required": "Неправильный метод запроса. POST требуется",
  "Incrorrect type_id": "Неверный type_id",
  "Bad Request": "Неверный запрос",
  "You are not loged in": "Вы не авторизованы",
  "Wrong type of request POST required": "Неправильный тип запроса POST требуется",
  "Only owner can manual control printer.": "Только владелец может вручную управлять принтером.",
  "Page was not found": "Страница не найдена",
  "Wrong job_id": "Неверный job_id",
  "No access to job": "Нет доступа к работе",
  "Fatal error: slicing error": "Фатальная ошибка: ошибка нарезки",
  "No file": "Нет файла",
  "Can not delete from bd": "Не могу удалить с бд",
  "Printer not ready": "Принтер не готов",
  "Incorrect gcode file": "Неверный файл gcode",
  "You have no access to this project status workflow": "У вас нет доступа к этому рабочему процессу статуса проекта",
  "Can not update BD": "Не могу обновить BD",
  "Incorrect type in API request": "Неверный тип в запросе API",
  "No POST data": "Нет данных POST",
  "Job does not exists": "Работа не существует",
  "Incorrect job_id #2": "Неверный job_id # 2",
  "User was not found": "Пользователь не найден",
  "Wrong job": "Неправильная работа",
  "Access deny": "Доступ запрещен",
  "You are not authorized": "Вы не авторизованы",
  "Validation error": "Ошибка проверки",
  "You have no access to this printer for sharing (maybe it is not part of your organization": "У вас нет доступа к этому принтеру для совместного использования (возможно, это не часть вашей организации",
  "Wrong input data": "Неверные входные данные",
  "Bad HTTP request": "Неверный HTTP-запрос",
  "Only the members of organization which this project owner belongs to have access to the project status tracking.": "Только члены организации, к которой принадлежит этот владелец проекта, имеют доступ к отслеживанию статуса проекта.",
  "No access to this project": "Нет доступа к этому проекту",
  "Incorrect input": "Неверный ввод",
  "No access to this file": "Нет доступа к этому файлу",
  "No access to workgroups list": "Нет доступа к списку рабочих групп",
  "File is not valid": "Файл недействителен",
  "Can't get file from s3": "Не могу получить файл с s3",
  "No status tracking enabled": "Отслеживание статуса не включено",
  "Request must be POST": "Запрос должен быть POST",
  "VID&PID don't match printer type": "VID и PID не соответствуют типу принтера",
  "Authorisation error": "Ошибка авторизации",
  "Printer type not choosen": "Тип принтера не выбран",
  "Job is not INQUEUE state": "Работа не в состоянии INQUEUE",
  "No application name": "Нет названия приложения",
  "No application found or some internal error": "Приложение не найдено или внутренняя ошибка",
  "Can not insert in BD": "Не могу вставить в BD",
  "Authentication error": "Ошибка аутентификации",
  "Job not found": "Работа не найдена",
  "Wrong file_id": "Неверный идентификатор_файла",
  "No render picture": "Нет изображения",
  "This printer is not belong to your organization.": "Этот принтер не принадлежит вашей организации.",
  "Incorrect token": "Неверный токен",
  "Type is already exists": "Тип уже существует",
  "DB error": "Ошибка БД",
  "User email does not fit organisation email mask": "Электронная почта пользователя не соответствует маске электронной почты организации",
  "Error in input": "Ошибка при вводе",
  "timeout": "Тайм-аут",
  "reCaptcha token is not valid": "токен reCaptcha недействителен",
  "No access for this user": "Нет доступа для этого пользователя",
  "Provided printer client was not found": "Предоставленный клиент принтера не найден",
  "Problem with obtain printer owner info": "Проблема с получением информации о владельце принтера",
  "Too many tries to generate token. Please try later.": "Слишком много попыток сгенерировать токен. Пожалуйста, попробуйте позднее.",
  "The registration token has been used already.": "Токен регистрации уже использован.",
  "Empty name parameter": "Пустой параметр имени",
  "The provided registration token was not found.": "Указанный регистрационный токен не найден.",
  "Wrong steps parameter": "Неверный параметр шагов",
  "No access to default slicing settings": "Нет доступа к настройкам нарезки по умолчанию",
  "Incorrect job status": "Неверный статус работы",
  "Unexpected response from Microsoft Live Connect": "Неожиданный ответ от Microsoft Live Connect",
  "There are no such keys in payload: ": "В полезной нагрузке нет таких ключей:",
  "No access to workflow": "Нет доступа к рабочему процессу",
  "Unexpected response from Microsoft Graph": "Неожиданный ответ от Microsoft Graph",
  "Invalid Access Token payload - can't find user email": "Недопустимая полезная нагрузка токена доступа - не удается найти адрес электронной почты пользователя",
  "Invalid Access Token payload": "Неверный токен доступа",
  "Unexpected response from Dremel IdSrv": "Неожиданный ответ от Dremel IdSrv",
  "Problem on job canceling": "Проблема при отмене работы",
  "Incorrect printer type from client": "Неверный тип принтера от клиента",
  "Wrong session": "Неправильный сеанс",
  "No Such Driver": "Нет такого драйвера",
  "printer auth error": "ошибка аутентификации принтера",
  "Username is not valid": "Неверное имя пользователя",
  "Incorrect credentials": "Неверные учетные данные",
  "User does not bind to any organisation": "Пользователь не привязан ни к одной организации",
  "Wrong printer from token": "Неправильный принтер из токена",
  "empty printer client": "пустой клиент принтера",
  "No access to custom profile": "Нет доступа к пользовательскому профилю",
  "No such type in allowed types": "Нет такого типа в разрешенных типах",
  "Need to specify a type of apps": "Нужно указать тип приложений",
  "Cannot send email": "Не могу отправить письмо",
  "wrong printer client": "неправильный клиент принтера",
  "Invalid Access Token": "Недопустимый маркер доступа",
  "Generate new registration code error (too many tries": "Создать новый код регистрации ошибки (слишком много попыток",
  "user was not found": "пользователь не найден",
  "Wrong email_hash": "Неверный email_hash",
  "Wrong user": "Неправильный пользователь",
  "Empty Access Token": "Токен пустого доступа",
  "API config does not exists": "Конфиг API не существует",
  "Must be AJAX request": "Должен быть AJAX запрос",
  "error": "ошибка",
  "Wrong workgroup id": "Неверный идентификатор рабочей группы",
  "Registration error": "Ошибка регистрации",
  "Payment system does not configured": "Платежная система не настроена",
  "Invalid project": "Неверный проект",
  "Project not defined": "Проект не определен",
  "Stripe config does not exists": "Конфигурация полосы не существует",
  "Wrong type": "Неверный тип",
  "No files to print": "Нет файлов для печати",
  "The Stripe Token was not generated correctly": "Токен Stripe не был сгенерирован правильно",
  "Invalid arguments": "Неверные аргументы",
  "share type was not found": "тип ресурса не найден",
  "Note is empty": "Примечание пусто",
  "Begin transaction error": "Ошибка начала транзакции",
  "Invalid file id": "Неверный идентификатор файла",
  "Wrong page": "Неправильная страница",
  "Userpage was not found": "Страница пользователя не найдена",
  "Frontend server is not available": "Фронтенд-сервер недоступен",
  "Papercut Balance: Error while retrieving username": "Papercut Balance: ошибка при получении имени пользователя",
  "Failed to duplicate workflow": "Не удалось продублировать рабочий процесс",
  "Only industrial or offline printers can be deleted.": "Только промышленные или автономные принтеры могут быть удалены.",
  "Send metrics": "Отправить метрики",
  "Get access token: analyze results": "Получить токен доступа: проанализировать результаты",
  "Get access token": "Получить токен доступа",
  "Some non pending state on copy operation": "Некоторое незавершенное состояние при операции копирования",
  "Balance update error": "Ошибка обновления баланса",
  "test1": "test1",
  "Wrong disconnected printer_id": "Неправильно отключен printer_id",
  "Fixed file len is not expected": "Фиксированный файл len не ожидается",
  "Fixed file is smaller then original": "Фиксированный файл меньше оригинала",
  "Failed to upload file to 3DPrinterOS": "Не удалось загрузить файл в 3DPrinterOS",
  "Failed to get file link": "Не удалось получить ссылку на файл",
  "Papercut Balance: Wrong url or authtoken": "Баланс Papercut: Неверный URL или Authtoken",
  "Failed to receive thing files": "Не удалось получить файлы вещей",
  "Invalid thing ID": "Неверный идентификатор вещи",
  "Wrong real printer_id": "Неверный реальный printer_id",
  "Empty user_id": "Пустой user_id",
  "Printer already have active job": "Принтер уже имеет активную работу",
  "Jon is not in queue state": "Джон не в состоянии очереди",
  "No projects": "Нет проектов",
  "Job list is wrong": "Список вакансий неверен",
  "File type is not supported": "Тип файла не поддерживается",
  "Can not insert in bd": "Не могу вставить в бд",
  "Can not update bd": "Не могу обновить бд",
  "Balance update: Unknown error": "Обновление баланса: неизвестная ошибка",
  "File is too big (greater then 1G": "Файл слишком большой (больше 1G",
  "Next users are wrong (not exists or not a part of organisation": "Следующие пользователи не правы (не существует или не является частью организации",
  "No consent selected": "Согласие не выбрано",
  "Max retries! Exiting...": "Макс повторяется! Выход ...",
  "No users in list": "Нет пользователей в списке",
  "Value of period need to be greater then 0.5 hour": "Значение периода должно быть больше 0,5 часа",
  "Fields for custom report are not set": "Поля для пользовательского отчета не установлены",
  "User is not in organization": "Пользователь не в организации",
  "Workgroup Moderators feature is not supported in your organisation": "Функция модераторов рабочей группы не поддерживается в вашей организации",
  "You have no license to use workgroups": "У вас нет лицензии на использование рабочих групп",
  "Wrong workgroup": "Неправильная рабочая группа",
  "Application already exist": "Приложение уже существует",
  "Failed (Beta": "Не удалось (бета",
  "Some error on set user organisation": "Некоторая ошибка при настройке организации пользователя",
  "Fatal error: slicer + toolpath error": "Фатальная ошибка: слайсер + ошибка траектории",
  "This printer type is not available for imprinta client": "Этот тип принтера недоступен для клиента imprinta",
  "Printer with this SNR was aleady registered": "Принтер с этим SNR уже зарегистрирован",
  "No way to connect printer with real user": "Нет способа подключить принтер к реальному пользователю",
  "Error: Parsed STL files does not exists": "Ошибка: проанализированные файлы STL не существует",
  "Error on retrieving job start time": "Ошибка при получении времени начала работы",
  "Existed row found": "Найдена существующая строка",
  "Cloud storage save file error": "Ошибка сохранения файла в облачном хранилище",
  "Fatal error: command prepare error": "Неустранимая ошибка: ошибка подготовки команды",
  "No access for selected company name": "Нет доступа для выбранного названия компании",
  "Error on combining g3drem header and gcode file": "Ошибка при объединении заголовка g3drem и файла gcode",
  "Error on creating thing file": "Ошибка при создании файла вещи",
  "Wrong job status": "Неправильный статус работы",
  "Error on workgroup_selection": "Ошибка при выборе рабочей группы",
  "Wrong download token": "Неправильный токен загрузки",
  "Empty download token": "Пустой токен загрузки",
  "Problem on download token generation. Please try again later": "Задача по генерации токенов загрузки. Пожалуйста, попробуйте позже",
  "User is a member of other organisation": "Пользователь является членом другой организации",
  "User has unallowed email domain for this organisation": "У пользователя есть запрещенный домен электронной почты для этой организации",
  "Job already has finished state": "Работа уже завершена",
  "You have no access to printing job": "У вас нет доступа к работе печати",
  "No printer quota": "Нет квоты на принтер",
  "Queue is disabled for this printer": "Очередь отключена для этого принтера",
  "Build tray is not clear": "Сборка лотка не понятна",
  "The material on printer is not enough to print this file": "Материалов на принтере недостаточно для печати этого файла",
  "Your printing limit is reached. Please contact your lab administrator.": "Ваш предел печати достигнут. Пожалуйста, свяжитесь с администратором вашей лаборатории.",
  "Your monthly quota of prints is reached. Please contact your lab administrator.": "Ваша месячная квота отпечатков достигнута. Пожалуйста, свяжитесь с администратором вашей лаборатории.",
  "You have no access to print file for that printer type": "У вас нет доступа к файлу печати для этого типа принтера",
  "You have no rights to use this printer": "У вас нет прав на использование этого принтера",
  "User can start only owned job": "Пользователь может начать только свою работу",
  "You have no rights to use this file": "У вас нет прав на использование этого файла",
  "Wrong data to print job": "Неправильные данные для печати задания",
  "Wrong file_id in job": "Неверный file_id в работе",
  "No profile_id or printer_type_id": "Нет идентификатора профиля или типа_принтера",
  "Incorrect profile_id": "Неверный идентификатор профиля",
  "Printer is not idle": "Принтер не простаивает",
  "User balace can't be changed to absolute amount for job": "Баланс пользователя не может быть изменен на абсолютную сумму за работу",
  "No access to start job": "Нет доступа к началу работы",
  "You can't copy profiles between different slicers": "Вы не можете копировать профили между разными слайсерами",
  "User is not member of this organisation": "Пользователь не является членом этой организации",
  "No archive in downloaded file": "В загруженном файле нет архива",
  "Can not update DB": "Не могу обновить БД",
  "Empty organisation id": "Пустой идентификатор организации",
  "Some problem on workgroup update": "Некоторая проблема при обновлении рабочей группы",
  "Empty reCaptcha token": "Пустой токен reCaptcha",
  "Error on file move": "Ошибка при перемещении файла",
  "No file in archive": "Нет файла в архиве",
  "Error on file save": "Ошибка при сохранении файла",
  "NO THINGEVERSE!": "НЕТ ВЕЩИ!",
  "Can not find settings. Maybe it was deleted": "Не могу найти настройки. Может быть, это было удалено",
  "Job was not created in your organization": "Работа не была создана в вашей организации",
  "You have no access to this job": "У вас нет доступа к этой работе",
  "Only org admin can use Global Archive": "Только администратор org может использовать Глобальный Архив",
  "Invalid printing quota period": "Неверный период квоты на печать",
  "Empty host": "Пустой хост",
  "User can start only next job in queue": "Пользователь может начать только следующую работу в очереди",
  "Can not insert in DB": "Не могу вставить в БД",
  "Could not find file dynamic options": "Не удалось найти динамические параметры файла",
  "Database error": "ошибка базы данных",
  "release type not found": "тип выпуска не найден",
  "Invalid SP name": "Неверное имя SP",
  "Invalid release type": "Неверный тип выпуска",
  "You have not permissions to disable status tracking": "У вас нет прав для отключения отслеживания статуса",
  "Status tracking already enabled for this project": "Отслеживание статуса уже включено для этого проекта",
  "Only student_name@purdue.edu emails": "Только электронная почта student_name@purdue.edu",
  "One (or more": "Один или больше",
  "Enter emails!": "Введите электронные письма!",
  "Not authenticated": "Не аутентифицирован",
  "Release_type not found": "Тип выпуска не найден",
  "No type in API request": "Нет типа в запросе API",
  "API configuration does not exists for your account": "Конфигурация API не существует для вашей учетной записи",
  "An error occurred while change project price": "Произошла ошибка при изменении цены проекта",
  "Not found": "Не найдено",
  "You are logged in. Please logout and use activation link again": "Вы вошли в систему. Пожалуйста, выйдите из системы и снова используйте ссылку активации",
  "Failed to update printer sharing quota": "Не удалось обновить квоту общего доступа к принтеру",
  "Incorrect action": "Неправильное действие",
  "Tutorial file was not found": "Учебный файл не найден",
  "Can't find remote terminal for that host": "Не могу найти удаленный терминал для этого хоста",
  "Failed to start RPi generation": "Не удалось запустить генерацию RPi",
  "Incorrect referer": "Неверный реферер",
  "Workgroup Moderator has no access to filter feature": "Модератор рабочей группы не имеет доступа к функции фильтра",
  "Not gcode file": "Не файл gcode",
  "No gcodes or command parameter": "Нет кодов или параметров команды",
  "Printer is not ready for manual control": "Принтер не готов к ручному управлению",
  "File info not found": "Информация о файле не найдена",
  "Incorrect app_job_id": "Неверный app_job_id",
  "Failed to get file information": "Не удалось получить информацию о файле",
  "File not exists": "Файл не существует",
  "You don't have access to such file id.": "У вас нет доступа к такому идентификатору файла.",
  "printer_type_id was already selected for this file": "printer_type_id уже был выбран для этого файла",
  "Incorrect printer_type_id": "Неверный printer_type_id",
  "This API request must have email as POST parameter": "Этот запрос API должен иметь электронную почту в качестве параметра POST",
  "Image does not exists": "Изображение не существует",
  "Invalid image ID": "Неверный идентификатор изображения",
  "Incorrect Login": "Неверный логин",
  "User with this email already exists": "Пользователь с таким адресом электронной почты уже существует",
  "Incrorrect origin": "Неверное происхождение",
  "This API request must be called by AJAX": "Этот запрос API должен вызываться AJAX",
  "This API request must not be called by AJAX": "Этот запрос API не должен вызываться AJAX",
  "Incorrect email format": "Неверный формат электронной почты",
  "Wrong Workgroup Moderator for filter feature": "Неправильный модератор рабочей группы для функции фильтра",
  "You have no access to this user": "У вас нет доступа к этому пользователю",
  "No image": "Нет изображения",
  "You can't restore password for not activated account. Please register again or activate your account.": "Вы не можете восстановить пароль для не активированной учетной записи. Пожалуйста, зарегистрируйтесь снова или активируйте свою учетную запись.",
  "Incorrect password": "неверный пароль",
  "Wrong access rights for workgroup": "Неправильные права доступа для рабочей группы",
  "Workgroup Moderator has no access to this function": "Модератор рабочей группы не имеет доступа к этой функции",
  "Search engine not found": "Поисковая система не найдена",
  "Deprecated": "Устаревшее",
  "Empty registration token": "Пустой регистрационный токен",
  "Test 500 error": "Ошибка теста 500",
  "Error on auth file generating": "Ошибка при создании файла аутентификации",
  "user_exists": "user_exists",
  "Wrong access role": "Неправильная роль доступа",
  "Empty email": "Пустое письмо",
  "Log file can't exceed 100M": "Файл журнала не может превышать 100M",
  "No file_data parameter": "Нет параметра file_data",
  "Problem on image saving": "Проблема с сохранением изображения",
  "Wrong registration_code_length. Must be larger then 3.": "Неправильный код регистрации Должно быть больше 3.",
  "Wrong registration_code_ttl. Must be in interval from 1 to 30 minutes.": "Неправильный регистрационный_код_ттл. Должен быть в интервале от 1 до 30 минут.",
  "Route not found": "Маршрут не найден",
  "Wrong parameters": "Неверные параметры",
  "There is empty user email": "Есть пустая электронная почта пользователя",
  "You have no access to add users with admin role": "У вас нет доступа для добавления пользователей с ролью администратора",
  "This workgroup is not in your organization": "Эта рабочая группа не в вашей организации",
  "You can not ban yourself": "Вы не можете забанить себя",
  "You have no access to this workgroup": "У вас нет доступа к этой рабочей группе",
  "No rights to work with workgroups": "Нет прав на работу с рабочими группами",
  "Empty request": "Пустой запрос",
  "Failed to update question": "Не удалось обновить вопрос",
  "Failed to add new question": "Не удалось добавить новый вопрос",
  "User already exists": "Пользователь уже существует",
  "There are errors in input data": "Есть ошибки во входных данных",
  "Account is not in your organisation": "Аккаунт не в вашей организации",
  "Wrong workgroup_id": "Неверный идентификатор рабочей группы",
  "Some error": "Какая-то ошибка",
  "DB error. Check input data.": "Ошибка БД. Проверьте входные данные.",
  "Workflow with such name already exists in your organization": "Рабочий процесс с таким именем уже существует в вашей организации",
  "You don't have rights to revoke admin role of this user": "У вас нет прав на отзыв роли администратора этого пользователя",
  "You can't revoke admin role from yourself": "Вы не можете отменить роль администратора у себя",
  "You can't exclude yourself": "Вы не можете исключить себя",
  "You don't have rights to delete this user": "У вас нет прав на удаление этого пользователя",
  "You don't have rights to delete this admin": "У вас нет прав на удаление этого администратора",
  "You can't delete yourself": "Вы не можете удалить себя",
  "Wrong usage": "Неправильное использование",
  "Can't change state to pause": "Не могу изменить состояние, чтобы приостановить",
  "File are not owned": "Файл не принадлежит",
  "Wrong period": "Неправильный период",
  "Internal error": "Внутренняя ошибка",
  "This account is not activated. You need to activate it using 3DPrinterOS cloud.": "Этот аккаунт не активирован. Вам необходимо активировать его с помощью облака 3DPrinterOS.",
  "Incorrect Username or Password": "Неверное имя пользователя или пароль",
  "You are already logged in": "Вы уже вошли в систему",
  "#1:Invalid license key": "#1: Неверный лицензионный ключ",
  "#0:Invalid license key": "#0: Неверный лицензионный ключ",
  "The number of attempts is exhausted": "Количество попыток исчерпано",
  "Incorrect vals (#2": "Неверные значения (# 2",
  "Invalid printer type alias": "Неверный псевдоним типа принтера",
  "Incorrect vals": "Неверные значения",
  "no action": "бездействие",
  "No access to host": "Нет доступа к хосту",
  "Wrong host id": "Неверный идентификатор хоста",
  "Wrong input": "Неправильный ввод",
  "No job_id": "No job_id",
  "Empty registration_token": "Пустой регистрационный_кен",
  "Error on job update": "Ошибка при обновлении задания",
  "Wrong id": "Неверный идентификатор",
  "File does not exists": "Файл не существует",
  "You can replace file only on job for virtual printer": "Вы можете заменить файл только на работу для виртуального принтера",
  "No theme parameter": "Нет параметра темы",
  "Not a POST method": "Не метод POST",
  "Incorrect user id": "Неверный идентификатор пользователя",
  "Incorrect printer id": "Неверный идентификатор принтера",
  "File not found": "Файл не найден",
  "Can not delete promotion project": "Не могу удалить продвижение проекта",
  "No required email parameter": "Нет обязательного параметра электронной почты",
  "Access denide": "Доступ запрещен",
  "Failed to save get support data": "Не удалось сохранить получить данные поддержки",
  "No such default profile_id": "Нет такого стандартного profile_id",
  "File ID must be defined": "Идентификатор файла должен быть определен",
  "Profile is not deleted": "Профиль не удален",
  "Failed to rename slicer profile": "Не удалось переименовать профиль слайсера",
  "Overwriting denied for this profile": "В этом профиле отказано в перезаписи",
  "Wrong role_id": "Неправильный ролевой идентификатор",
  "Some error on sharing": "Некоторая ошибка при обмене",
  "Printer Already Shared!": "Принтер уже поделился!",
  "You can't share printer to yourself": "Вы не можете поделиться принтером для себя",
  "User is not a member of your organization": "Пользователь не является членом вашей организации",
  "File not exists or you have no access": "Файл не существует или у вас нет доступа",
  "You can replace file only on job in queue": "Вы можете заменить файл только на работу в очереди",
  "Can't cancel state to printing": "Невозможно отменить состояние печати",
  "Some required parameter is empty": "Какой-то обязательный параметр пуст",
  "This serialnumber was already registered": "Этот серийный номер уже зарегистрирован",
  "Wrong serialnumber": "Неверный серийный номер",
  "Wrong id parameter": "Неверный параметр id",
  "Wrong printers parameter": "Неправильный параметр принтеров",
  "No action": "Нет доступа",
  "OAuth error: can't receive access token": "Ошибка OAuth: не может получить токен доступа",
  "Invalid user data from OnShape": "Неверные данные пользователя из OnShape",
  "No access to this host": "Нет доступа к этому хосту",
  "You did not log in": "Вы не авторизовались",
  "Empty search criteria": "Пустые критерии поиска",
  "Some share problem": "Некоторые разделяют проблему",
  "Printer already shared to that user": "Принтер уже поделился с этим пользователем",
  "User not exists": "Пользователь не существует",
  "Printer sharing is not available": "Общий доступ к принтеру недоступен",
  "The registration code appears empty.": "Регистрационный код выглядит пустым.",
  "No printer access": "Нет доступа к принтеру",
  "Can't find cloud client data": "Не удается найти данные облачного клиента",
  "Can't cancel job": "Не могу отменить работу",
  "Error link": "Ссылка на ошибку",
  "No information": "Нет информации",
  "Job not exists or you have no access": "Работа не существует или у вас нет доступа",
  "No jobs in queue, nothing to unpause": "Нет заданий в очереди, нет ничего, чтобы сделать паузу",
  "Wrong color": "Неверный цвет",
  "You need to have print access to printer for manual control": "Вы должны иметь доступ к принтеру для ручного управления",
  "Empty command": "Пустая команда",
  "Queue is empty": "Очередь пуста",
  "Only owner can reset camera": "Только владелец может сбросить камеру",
  "Error on cancel(false": "Ошибка при отмене (false",
  "Error on cancel(null": "Ошибка при отмене (ноль",
  "You have no rights to unpause on this printer": "У вас нет прав на приостановку на этом принтере",
  "You have no rights to pause on this printer": "У вас нет прав на паузу на этом принтере",
  "No Files": "Файлов нет",
  "No jobs in queue, nothing to pause": "Нет рабочих мест в очереди, нечего останавливаться",
  "Failed to deactivate printer": "Не удалось деактивировать принтер",
  "Wrong data given": "Неверные данные",
  "No access. You are not file owner.": "Нет доступа. Вы не являетесь владельцем файла.",
  "File is not deleted": "Файл не удален",
  "No access to file": "Нет доступа к файлу",
  "empty data": "пустые данные",
  "No file status": "Нет статуса файла",
  "Commit transaction error": "Ошибка совершения транзакции",
  "Wrong username or password!": "Неверное имя пользователя или пароль!",
  "not_activated": "не активирован",
  "User does not exists": "Пользователь не существует",
  "New job was queued. Error on job starting: Printer already have active job": "Новая работа была поставлена в очередь. Ошибка при запуске задания: принтер уже имеет активное задание",
  "Error on job starting: Printer already have active job": "Ошибка при запуске задания: принтер уже имеет активное задание",
  "A user with this email already exists": "Пользователь с таким адресом электронной почты уже существует",
  //"You have already sent one job on the printing. You can send only one object at one time. Try again when it will be completed (finished\/failed\/aborted).": "Вы уже отправили одну работу на печать. Вы можете отправить только один объект за один раз. Попробуйте еще раз, когда это будет завершено (завершено\/ошибка\/прервано).",
  "This email do not belong to any existing users": "Это письмо не принадлежит ни одному из существующих пользователей.",
  "This email is already verified.": "Это письмо уже подтверждено.",
  "You can't share file to yourself": "Вы не можете поделиться файлом с самим собой",
  "You already had profile with same name for this printer type.\nPlease change profile name to save.": "У вас уже был профиль с тем же именем для этого типа принтера. Пожалуйста, измените имя профиля, чтобы сохранить.",
  "Your balance is insufficient to print this file": "Ваш баланс недостаточен для печати этого файла",
  "We can't create the account without your consent on proceeding your email": "Мы не можем создать учетную запись без вашего согласия на продолжение вашей электронной почты",
  "You can't share project to yourself": "Вы не можете поделиться проектом для себя",
  "New job was queued. Error on job starting: Printer is not idle": "Новая работа была поставлена в очередь. Ошибка при запуске задания: принтер не находится в режиме ожидания",
  "Error on job starting: Printer is not idle": "Ошибка при запуске задания: принтер не находится в режиме ожидания",
  "printer_type_id must not be empty!<br>": "Тип принтера не должен быть пустым! <br>",
  "It is not possible to delete printer shared using workgroups. Please use \"Make inanctive\" instead.": "Невозможно удалить принтер добавленный с помощью рабочих групп. Пожалуйста, используйте \"Сделать неактивным\" вместо этого.",
  "You can't create an account with this email domain in this way. Use SSO type of registration": "Вы не можете создать учетную запись с этим доменом электронной почты таким образом. Использовать SSO тип регистрации",
  "Email is wrong. Please use the email you've specified during the registration.": "Адрес электронной почты неверен. Пожалуйста, используйте адрес электронной почты, который вы указали при регистрации.",
  "password - not exceed 64 characters" : "Пароль не должен быть длиннее 64 символов",
  "phone must be a phone number" : "Телефон должен быть номером телефона",
  "Some error on file sharing" : "Произошла ошибка при обмене файлами",
}
